import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What educational background is required to start learning Cloud Engineering?",
    
    description:
      "You don’t need a specific degree for Cloud Engineering. Students from IT, engineering, or networking backgrounds adapt faster, but beginners can learn easily with guidance. What matters most is understanding technical concepts and having interest in cloud platforms.",
  },
  {
    title: "What job roles are available in the Cloud Engineering field?",
    
    description:
      "Cloud Engineering offers roles like Cloud Engineer, Cloud Administrator, DevOps Engineer, Solutions Architect, Cloud Security Engineer, SRE, Cloud Support Engineer, and Cloud Consultant. Each role focuses on managing infrastructure, designing solutions, automating deployments, or strengthening cloud security.",
  },
  {
    title: "What are the career growth opportunities in Cloud Engineering?",
    
    description:
      "Cloud Engineering is rapidly growing, offering roles from Cloud Support Associate to Senior Engineer, Architect, or DevOps Lead. As companies adopt AWS, Azure, and GCP, demand for skilled cloud professionals keeps rising, creating excellent long-term career opportunities.",
  },
  {
    title: "What tools and technologies are commonly used in Cloud Engineering?",
    
    description:
      "Cloud Engineers use tools like AWS, Azure, GCP, Docker, Kubernetes, Terraform, Jenkins, GitHub, Ansible, and Linux. These technologies help automate deployments, manage cloud infrastructure, monitor systems, and maintain secure, scalable cloud environments.",
  },
  {
    title: "Do I need cloud certifications for a Cloud Engineering career?",
   
    description:
      "Cloud certifications greatly enhance career prospects. Popular ones include AWS Cloud Practitioner, AWS Solutions Architect, Azure Fundamentals, Azure Administrator, and Google Associate Cloud Engineer. They aren’t mandatory initially but significantly improve credibility and job opportunities.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
